<template>
  <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">

    <!-- GENERAL -->
    <vs-tab v-if="webname==='SOLO'" icon-pack="feather" icon="icon-user" :label="!isSmallerScreen ? 'เติม-ถอนเครดิต (ปกติ) SOLO' : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <Agentsolo />
      </div>
    </vs-tab>
    <vs-tab v-else icon-pack="feather" icon="icon-user" :label="!isSmallerScreen ? 'เติม-ถอนเครดิต (ปกติ)' : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <Agentall />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-user" :label="!isSmallerScreen ? 'เติม-ถอนเครดิต (UFA)' : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <Agentufa />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-user" :label="!isSmallerScreen ? 'เติม เครดิต(พิเศษ กันเบิ้ล)' : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <AgentSpecial />
      </div>
    </vs-tab>
  </vs-tabs>
</template>

<script>
import Agentall from './Agentalll'
import Agentscb from './Agentscb'
import Agentscbonly from './Agentscbonly'
import Agentkbank from './Agentkbank'
import Agentkbankonly from './Agentkbankonly'
import Agentsolo from './Agentsolo'
import AgentSpecial from './AgentSpecial'
import Agentufa from './Agentufa'

export default {
  components: {
    AgentSpecial,
    Agentall,
    Agentsolo,
    Agentufa,
    Agentscb,
    Agentkbank,
    Agentscbonly,
    Agentkbankonly

  },
  data () {
    return {
      webname: process.env.VUE_APP_TITLE
    }
  },
  computed: {
    isSmallerScreen () {
      return this.$store.state.windowWidth < 768
    }
  },
  mounted () {
    if (!this.$store.state.AppActiveUser.permissions.addcredit.action) this.$router.push('/error-404')
  }
}
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
